// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearcBar_searchContainer__gceBA","closeButton":"SearcBar_closeButton__2C8fg","inputSearch":"SearcBar_inputSearch__nEZkB"};